import React, { useEffect } from "react";
import HomeReviews from "../components/homepage-components/HomeReviews";
import Faq from "../components/universal-components/Faq";
import Hero from "../components/Hero";
import Intro from "../components/Intro";
import ContentLeft from "../components/ContentLeft";
import ContentRight from "../components/ContentRight";
import CallToAction from "../components/CallToAction";
import { underfloorContent } from "../page-content/underfloorContent";

const UndefloorHeating = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero data={underfloorContent} />
      <Intro data={underfloorContent} />
      <ContentLeft data={underfloorContent} />
      <ContentRight data={underfloorContent} />
      <CallToAction data={underfloorContent} />
      <HomeReviews />
      <Faq />
    </>
  );
};

export default UndefloorHeating;
